export var Type;
(function (Type) {
    Type["AREA"] = "AREA";
    Type["ROW"] = "ROW";
    Type["MULTI_ROW"] = "MULTI_ROW";
    Type["TABLE"] = "TABLE";
    Type["ROUND_TABLE"] = "ROUND_TABLE";
    Type["SHAPE"] = "SHAPE";
})(Type || (Type = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Fieldset;
(function (Fieldset) {
    Fieldset["ELEMENTS"] = "ELEMENTS";
    Fieldset["CATEGORIES"] = "CATEGORIES";
    Fieldset["PLACES"] = "PLACES";
    Fieldset["CONFIG"] = "CONFIG";
})(Fieldset || (Fieldset = {}));
//# sourceMappingURL=types.impl.js.map